import { PROVIDER_LABELS } from "../constants/providerLabels.constant";
import { MissionProvider } from "../types/missionProvider.type";

export class MissionProvidersTransformer {
  static humanizeProviderKlass(klass?: string) {
    if (!klass) return undefined;
    if (PROVIDER_LABELS[klass]) return PROVIDER_LABELS[klass];

    const raw = klass.split("::").pop() || klass;
    const withSpaces = raw.replace(/([A-Z])/g, " $1").trim();

    return withSpaces.length ? withSpaces : raw;
  }

  static normalizeProviders(payload: unknown): MissionProvider[] {
    if (!Array.isArray(payload)) return [];

    return payload
      .map((item) => {
        if (typeof item === "string") {
          return { provider_klass: item };
        }

        if (item && typeof item === "object") {
          const provider =
            (item as { provider_klass?: string; providerKlass?: string })
              .provider_klass ??
            (item as { providerKlass?: string }).providerKlass;
          const displayName =
            (item as { display_name?: string; displayName?: string })
              .display_name ??
            (item as { displayName?: string }).displayName;
          const description = (item as { description?: string }).description;

          if (typeof provider === "string" && provider.length > 0) {
            return {
              provider_klass: provider,
              display_name:
                typeof displayName === "string" ? displayName : undefined,
              description:
                typeof description === "string" ? description : undefined,
            };
          }
        }

        return null;
      })
      .filter(
        (provider): provider is MissionProvider =>
          Boolean(provider?.provider_klass),
      );
  }
}
